import { Button, Card, Stack, Text } from '@mantine/core';
import { redirectTo } from '@dealstack/frontend/shared/redirecting';

interface Props {
	status: 'enabled' | 'disabled' | 'unavailable';
	title: string;
	subtitle: string;
	description: string;
	buttonText: string;
	body: string;
	subject: string;
}

export const OrganizationAuthPolicyCard = ({
	status,
	title,
	subtitle,
	description,
	buttonText,
	body,
	subject,
}: Props) => {
	const isUnavailable = status === 'unavailable';
	const titleColor = status === 'enabled' ? '#00A36D' : '#0E171C';
	const descriptionBorder = status === 'enabled' ? '#00A36D' : '#F2870D';

	const handleClick = () => {
		redirectTo(`mailto:support@dealstack.io?subject=${subject}&body=${body}`);
	};

	return (
		<Card
			padding="md"
			bg="#FFF"
			radius={8}
			sx={{
				border: `1px solid #E9EBED`,
				opacity: isUnavailable ? 0.5 : 1,
			}}
			data-testid="organization-auth-policy-card"
		>
			<Stack gap="md">
				<Text
					c={titleColor}
					fz={14}
					fw={600}
					lh="20px"
					ff="Inter"
					style={{ fontVariantNumeric: 'lining-nums tabular-nums' }}
				>
					{title}
				</Text>

				<Text
					c="#0E171C"
					fz={14}
					fw={400}
					lh="20px"
					ff="Inter"
					style={{ fontVariantNumeric: 'lining-nums tabular-nums' }}
				>
					{subtitle}
				</Text>

				<Card
					p={16}
					radius={8}
					sx={{
						border: `1px solid ${descriptionBorder}`,
						backgroundColor: '#FFF',
					}}
					data-testid="organization-auth-policy-description"
				>
					<Text c="#0E171C" fz={14} fw={400} lh="20px" ff="Inter">
						{description}
					</Text>
				</Card>

				<Button disabled={isUnavailable} w="fit-content" onClick={handleClick}>
					{buttonText}
				</Button>
			</Stack>
		</Card>
	);
};
